var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({key:_vm.name,staticClass:"icon",class:_vm.classNames},_vm.$listeners),[_c('svg',{staticClass:"icon-svg"})])}
var staticRenderFns = []

export { render, staticRenderFns }